import { LocaleAnchor } from '@/i18n/router';
import { useMessages } from '@/i18n/LocaleProvider';
import messages from '@/i18n/catalogs/corporate/CtaSection';

import React from 'react';

import { Link } from '@/i18n/router';
import { Button } from '@/components/ui/button';
import { Mail, Phone, MessageSquare, ArrowRight } from 'lucide-react';
import SectionHeading from '@/components/SectionHeading';

const CtaSection = ({ tone = 'gizmo' }: { tone?: 'gizmo' | 'hardcharger' }) => {
  const m = useMessages(messages);


  return (
    <section id="contact" className={`scroll-mt-24 text-white ${tone === 'hardcharger' ? 'bg-hc-navy' : 'bg-gizmo-600'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info & Quick Links */}
          <div>
            <SectionHeading anchor="contact" className="text-3xl md:text-4xl font-bold mb-4">{m.s1}</SectionHeading>
            <p className="text-lg text-white/80 mb-8 max-w-md">{m.s2}</p>
            <div className="flex flex-col sm:flex-row gap-3 mb-8">
              <LocaleAnchor href="mailto:info@gizmodata.com">
                <Button
                  size="lg"
                  className={`bg-white hover:bg-white/90 dark:bg-white dark:hover:bg-white/90 font-medium shadow-md w-full sm:w-auto ${tone === 'hardcharger' ? 'text-hc-navy dark:text-hc-navy' : 'text-gizmo-600 dark:text-gizmo-600'}`}
                  data-ga-cta="email_us"
                  data-ga-location="contact_section"
                >
                  <Mail className="mr-2" size={18} />{m.s3}</Button>
              </LocaleAnchor>
              <LocaleAnchor href="tel:+18664496632">
                <Button
                  size="lg"
                  variant="outline"
                  className="bg-orange-500 text-white hover:bg-orange-600 dark:bg-orange-500 dark:text-white dark:hover:bg-orange-600 border-none font-medium shadow-md w-full sm:w-auto"
                  data-ga-cta="call_us"
                  data-ga-location="contact_section"
                >
                  <Phone className="mr-2" size={18} />
                  +1 (866) GIZMODATA
                </Button>
              </LocaleAnchor>
            </div>

            {/* Substack Newsletter Section */}
            <div className="mt-12 pt-8 border-t border-white/20">
              <h3 className="text-xl font-semibold mb-3">{m.s4}</h3>
              <p className="text-white/80 mb-4 text-sm">{m.s5}</p>
              <LocaleAnchor
                href="https://gizmodata.substack.com/subscribe"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  size="lg"
                  className={`bg-white hover:bg-white/90 dark:bg-white dark:hover:bg-white/90 font-medium shadow-md ${tone === 'hardcharger' ? 'text-hc-navy dark:text-hc-navy' : 'text-gizmo-600 dark:text-gizmo-600'}`}
                  data-ga-cta="newsletter_submit"
                  data-ga-location="contact_section"
                >{m.s6}</Button>
              </LocaleAnchor>
            </div>
          </div>

          {/* Contact CTA — the form now lives on the dedicated /contact page */}
          <div className="flex flex-col justify-center rounded-xl border border-white/10 bg-white/10 p-8 backdrop-blur-sm">
            <div className="mb-4 inline-flex w-fit rounded-full bg-white/15 p-3">
              <MessageSquare className="h-6 w-6" />
            </div>
            <h3 className="mb-3 text-xl font-semibold">{m.s7}</h3>
            <p className="mb-6 text-white/80">{m.s8}</p>
            <Link to="/contact?from=home_contact_section" className="w-fit">
              <Button
                size="lg"
                className={`bg-white font-medium shadow-md hover:bg-white/90 dark:bg-white dark:hover:bg-white/90 ${tone === 'hardcharger' ? 'text-hc-navy dark:text-hc-navy' : 'text-gizmo-600 dark:text-gizmo-600'}`}
                data-ga-cta="contact_us"
                data-ga-location="home_contact_section"
              >{m.s9}<ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
